import { ConfigSection } from '@components-fabric';
import { windowsSection } from './windows.screens';
import { floorsSection } from './floors.routes';
import { wallsSection } from './walls.screens';
import { roofsSection } from './roofs.screens';

/**
 * Components Section Configuration
 *
 * Defines the configuration for the components section, including nested sections.
 *
 * @type {ConfigSection}
 * @property {string} id - The unique identifier for the section.
 * @property {Array} screens - The array of screen configurations within the section (currently empty).
 * @property {Array} sections - The array of nested section configurations.
 */
export const componentsSection: ConfigSection = {
  id: 'components',
  screens: [],
  sections: [floorsSection, wallsSection, windowsSection, roofsSection],
};
